import Analysis from './components/Analysis';
export default Analysis;